import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class DefaultActionIcon extends BaseOption {
  static userInterfaceComponent = {
    label: "Default Action Icon",
    component: inspectorTools.ICON_PICKER,
  };

  static defaultValue = "bx:up-arrow";
}

